"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logger = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var Logger = /*#__PURE__*/function () {
  function Logger() {
    (0, _classCallCheck2.default)(this, Logger);
    this.env = process.env.NODE_ENV;
  }

  (0, _createClass2.default)(Logger, [{
    key: "info",
    value: function info() {
      if (this.env !== 'production') {
        var _console;

        (_console = console).log.apply(_console, arguments);
      }
    }
  }, {
    key: "warn",
    value: function warn() {
      if (this.env !== 'production') {
        var _console2;

        (_console2 = console).warn.apply(_console2, arguments);
      }
    }
  }, {
    key: "error",
    value: function error() {
      if (this.env !== 'production') {
        var _console3;

        (_console3 = console).error.apply(_console3, arguments);
      }
    }
  }]);
  return Logger;
}();

exports.Logger = Logger;